<template>
    <div
        class="form-group active"
        :class="[parentClass]"
    >
        <label
            v-if="label"
            :for="uniqueId"
            class="form-group-label"
        >
            {{ label }}

            <span
                v-if="optional"
                class="d-inline-flex ml-2 text-small"
            >
                {{ $t('general.optional') }}
            </span>
        </label>
        <div class="custom-file">
            <input
                v-bind="$attrs"
                @change="handleChange"
                @focusin="focus = true"
                @focusout="focus = false"
                type="file"
                class="custom-file-input"
                :id="uniqueId"
                :required="required && !inputValue"
            >
            <label
                :class="[{ readonly }, 'custom-file-label truncate']"
                :for="uniqueId"
            >
                {{ showValue }}
            </label>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'UiInputFile',
        inheritAttrs: false,
        props: {
            label: {
                type: String,
                default: null,
            },
            parentClass: {
                type: String,
                default: '',
            },
            readonly: {
                type: Boolean,
                default: false,
            },
            required: {
                type: Boolean,
                default: false,
            },
            optional: {
                type: Boolean,
                default: false,
            },
            value: {
                type: String,
                default: null,
            },
        },
        data() {
            return {
                focus: false,
                inputValue: this.value,
            };
        },
        computed: {
            moveLabelToTop() {
                return this.focus || !!this.inputValue;
            },

            uniqueId() {
                return this._uid;
            },

            showValue() {
                return this.inputValue || 'Select a file';
            },
        },
        methods: {
            handleChange(e) {
                this.inputValue = e.target.value.split('\\').pop();
                this.$emit('input', this.inputValue);
            },
        },
        watch: {
            value(newVal) {
                this.inputValue = newVal;
            },
        },
    };
</script>

<style lang="scss" scoped>
    .custom-file {
        &,
        &-input,
        &-label {
            height: 44px;
        }

        &-label {
            padding: 12px 96px 12px 16px;
            font-size: 14px;
            line-height: 18px;

            &::after {
                height: 42px;
                padding: 0 16px;
                line-height: 42px;
            }
        }
    }
</style>
